# out: $1.js, compress: false, sourcemap: true
module = ->
  window.validate_form = (elem) ->
    parent = $(elem).parent()
    isValid = true

    if !$personalAgreement.is(':checked')
      $personalAgreementError.show()
      return false

    $(parent).find('.filed-for-validate').each ->
      if !$(this).val()
        $(this).css 'border', '1px solid red'
        isValid = false
      else
        $(this).css 'border', '1px solid #00549A'
      return
    isValid

  $personalAgreement = $('#personal_data_agreement')
  $personalAgreementError = $('#no_agreement_error')
  $formToggler = $('#toggle_form')
  $personalAgreement.on 'change', ()->
    if !$personalAgreement.is(':checked')
      $formToggler.addClass('disabled')
      $personalAgreementError.show()
    else
      $formToggler.removeClass('disabled')
      $personalAgreementError.hide()

  $formToggler.click ->


    if $personalAgreement.length>0 && !$personalAgreement.is(':checked')
      $personalAgreementError.show()
      return

    if $(this).text() == 'Отмена'
      $personalAgreement.prop('disabled', false)
      $(this).text 'Подать анкету'
    else
      $personalAgreement.prop('disabled', true)
      $(this).text 'Отмена'
    $('.vacancies-forms-wrap').slideToggle 'normal'
    $('.vacancies-name').text $('.title-for-forms').text()
    $('#position').val $('.title-for-forms').text()
    return
  $('#send_resume').click ->
    if $(this).hasClass('vacancies-forms-ins-choice-buttons-current')
      return false
    $('.send-resume').slideToggle 'normal'
    $('.jobseekers-profile').hide()
    $(this).addClass 'vacancies-forms-ins-choice-buttons-current'
    $('#jobseekers_profile').removeClass 'vacancies-forms-ins-choice-buttons-current'
    return
  $('#jobseekers_profile').click ->
    if $(this).hasClass('vacancies-forms-ins-choice-buttons-current')
      return false
    $('.jobseekers-profile').slideToggle 'normal'
    $('.send-resume').hide()
    $(this).addClass 'vacancies-forms-ins-choice-buttons-current'
    $('#send_resume').removeClass 'vacancies-forms-ins-choice-buttons-current'
    return
  $ ->
    if $('#chose_file').length
      $('#chose_file').click ->
        $('#chose_file_input').click()
        false

      $("#send_resume_submit").click ()->
        return if $(this).hasClass('send-resume-submit-disabled')
        #$(this).parents("form").submit()
        $(this).parents("form").append(	$("#personal_data_agreement:checked").clone().attr("checked", "checked").attr("name", "user_argeement_check").attr("type", "hidden").removeAttr("disabled")).submit();
      $('#chose_file_input').change(->
        $('#chose_file_text').html $(this).val().replace('C:\\fakepath\\','')
        if $(this).val()
          $('#send_resume_submit').removeClass 'send-resume-submit-disabled'
        else
          $('#send_resume_submit').addClass 'send-resume-submit-disabled'
        return
      ).change()
    now = new Date
    this_year = now.getFullYear()
    i = 1950
    while i <= this_year
      $('#year_of_ending').append '<option value=' + i + '>' + i + '</option>'
      i++
    return
  $('#send_jobseekers_profile').click ->
    if validate_form this
      inputs = $("#jobseekers_profile_form input, select");
      form = $("#jobseekers_profile_form");
      url = form.attr("action");
      window.page.loading();
      $.post(url, form.serialize())
        .done ()->
          window.page.loaded()
          window.location = window.location+"?accept=true"
        .fail (data)->
          window.page.loaded()
          try
            error = $.parseJSON(data.responseText).error;
          catch
            error = data.responseText;
          window.page.badMessage(error)
    return
  $('.filed-for-validate').keyup ->
    validate_form $(this).parent()
    return
  $('.filed-for-validate').change ->
    validate_form $(this).parent()
    return

unit.define "site::vacansies_single", module, "site::all_pages"
